import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  standalone: true,
})
export class ReplacePipe implements PipeTransform {
  public transform(value: string, target: string | string[], replacement: string): string {
    if (!value || !target || typeof replacement !== 'string') {
      return value;
    }

    // Ensure target is an array
    const targets = Array.isArray(target) ? target : [target];

    // Escape special characters in the target strings
    const escapedTargets = targets.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

    // Create a regular expression that matches any of the targets
    const regex = new RegExp(escapedTargets.join('|'), 'gi');

    // Replace all matches with the replacement string
    return value.replace(regex, replacement);
  }
}
